import React from "react";

function DeleteAccount() {
  return (
    <div className="page">
      <style>{`
        .page {
          --bg: #0b0f14;
          --muted: #93a4b3;
          --text: #e5e7eb;
          --card: rgba(255, 255, 255, 0.06);
          --border: rgba(255, 255, 255, 0.09);
          --accent: #22c55e;
          min-height: 100vh;
          background:
            radial-gradient(40% 50% at 85% 10%, rgba(34, 197, 94, 0.15) 0%, rgba(0,0,0,0) 60%),
            radial-gradient(30% 35% at 10% 20%, rgba(34, 197, 94, 0.1) 0%, rgba(0,0,0,0) 60%),
            linear-gradient(180deg, #0b0f14 0%, #070b10 60%, #05070a 100%);
          color: var(--text);
        }

        .container { max-width: 1100px; margin: 0 auto; padding: 24px; }

        .card {
          max-width: 860px;
          margin: 48px auto;
          background: var(--card);
          border: 1px solid var(--border);
          border-radius: 16px;
          padding: 24px;
          line-height: 1.7;
        }

        .title {
          font-size: clamp(28px, 5vw, 36px);
          line-height: 1.15;
          letter-spacing: -0.02em;
          margin: 8px 0 8px;
          background: linear-gradient(180deg, #ffffff, #b9c2ca 60%, #7b8794);
          -webkit-background-clip: text; background-clip: text; color: transparent;
        }

        .muted { color: var(--muted); }
        p { margin: 10px 0; }
        ul { margin: 8px 0 16px 18px; }
        li { margin: 6px 0; }
        a { color: #86efac; }
        a:hover { text-decoration: underline; }
      `}</style>

      <div className="container">
        <section className="card">
          <h1 className="title">Delete Account or Data</h1>
          <p>
            To request deletion of your account or personal data, please send an
            email to <strong>contact@olinfinance.com</strong> from the email
            address associated with your Olin Finance account. If you cannot
            send from that address, include your registered account email in the
            message.
          </p>
          <p>Include the following in your email:</p>
          <ul>
            <li>Your account email address</li>
            <li>
              Whether you want to delete your entire account or specific data
            </li>
          </ul>
          <p>
            You can also click the link below to start an email draft:
            <br />
            <a href="mailto:contact@olinfinance.com?subject=Account%20or%20Data%20Deletion%20Request&body=Hello%2C%0A%0AI%20would%20like%20to%20request%20deletion%20of%20my%20account%20and%2For%20personal%20data.%0A%0AAccount%20email%3A%20%3Cyour-account-email%40example.com%3E%0ARequest%3A%20Delete%20entire%20account%20%7C%20Delete%20specific%20data%0A%0AThank%20you.">
              Email contact@olinfinance.com
            </a>
          </p>
        </section>
      </div>
    </div>
  );
}

export default DeleteAccount;
